<template>
  <v-row no-gutters>
    <v-col cols="12">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ExpansionPanelContentHeading",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped></style>
